import React from "react";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Brand = ({ data, language }) => {
  const settings = {
    infinite: data?.data_values.length > 1,
    speed: 5000,
    slidesToShow: Math.min(4, data?.data_values.length),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(4, data?.data_values.length || 1) },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: Math.min(3, data?.data_values.length || 1) },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: Math.min(2, data?.data_values.length || 1) },
      },
    ],
  };

  return (
    <div className="cs_brands_section mt-3">
      <div className="container">
        <div className="cs_section_heading cs_style_1 text-center mb-4">
          {language === "ar" ? (
            <h2 className="fw-bold fade-in" style={{ color: "#c69933" }}>
              شراكاتنا مع العلامات التجارية الموثوقة
            </h2>
          ) : (
            <h2 className="fw-bold fade-in" style={{ color: "#c69933" }}>
              Our Trusted Brand Collaborations
            </h2>
          )}
        </div>
        <Slider {...settings} className="">
          {data?.data_values?.map((brand, index) => (
            <div key={index} className="cs_slide">
              <div className="cs_brand  text-center">
                <img
                  src={brand?.logo}
                  alt="brandLogo"
                  style={{
                    width: "auto",
                    height: "60px",
                    objectFit: "contain",
                  }}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <hr
        className="mt-5 mx-auto"
        style={{
          height: "1px", // Increases thickness
          backgroundColor: "#b78c35", // Sets the color
          border: "none", // Removes default border
        }}
      />
    </div>
  );
};

export default Brand;
